<template>
  <v-container>
    <h2>Login</h2>
  </v-container>
</template>

<script setup>
import { inject, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { useRouter } from 'vue-router'

const router = useRouter();
const baseCalls = inject('baseCalls')
const loaderStore = inject('loaderStore');
const userStore = inject('userStore');
const successStore = inject('successStore');
const errorStore = inject('errorStore');
const { userData } = storeToRefs(userStore)

const route = useRoute();
async function startLogin() {

  console.log('startLogin jetzt');
  const data = { action: 'startlogin',token: route.params.token }
  //console.log(data);
  loaderStore.setLoader(true, "Bitte warten, Sie werden eingeloggt...");
  try {
    const response = await baseCalls.userPost(data);
    if (response.data.user ) {
      console.log('Benutzerdaten hier geladen:', response.data.user);
      userStore.setUser(response.data.user );
      loaderStore.setLoader(false);
      successStore.setSuccess(true, 'Sie wurden erfolgreich eingeloggt', 'Sie können jetzt z.B. neue Waizmanntabellen kostenlos anfordern.');
      if (route.params.redirect && route.params.redirect !== '' && route.params.redirect !== 'undefined') {
        console.log('push to redirect');
        console.log(route.params.redirect);
        handleRedirect();
      }else{
        console.log('push to waizmanntabellen_bestellen');
        setTimeout(() => {
    router.push('/waizmanntabellen_bestellen');
  }, 2000);
      }
    }  else {
      errorStore.setError( true, 'Fehler beim Laden der Benutzerdaten');
    }
  } catch (err) {
   
    errorStore.setError(true, 'Fehler beim Laden der Benutzerdaten');
    console.error('API-Fehler:', err);
  } finally {

    loaderStore.setLoader(false);
  }
}
function handleRedirect() {
  let redirect = route.params.redirect || '';
  if (route.params.id) {
    redirect = `/${redirect}/${route.params.id}`.replace(/\/+/g, '/');
  }
  setTimeout(() => {
    router.push(redirect);
  }, 2000);
}
onMounted(() => {
  if (!userData.value && route.params.token != null) {
    startLogin();
  }
});

  //import { reactive, ref } from "vue";
</script>
